import { makeStyles, Theme, createStyles } from '@material-ui/core';
import {
  IMAGE_AREA_WIDTH_2_3,
  IMAGE_AREA_HEIGHT_2_3,
  IMAGE_AREA_WIDTH_9_16,
  IMAGE_AREA_HEIGHT_9_16,
} from 'constants/style';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    containerHorizontal: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: IMAGE_AREA_WIDTH_9_16,
      height: IMAGE_AREA_HEIGHT_9_16,
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.spacing(2),
    },
    containerVertical: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: IMAGE_AREA_WIDTH_2_3,
      height: IMAGE_AREA_HEIGHT_2_3,
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.spacing(2),
    },
    title: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
      marginTop: theme.spacing(1),
      cursor: 'pointer',
    },
    subtitle: {
      color: theme.palette.text.disabled,
    },
    icon: {
      fontSize: theme.spacing(5),
      color: theme.palette.text.disabled,
    },
    iconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: theme.spacing(7.5),
      width: theme.spacing(7.5),
      borderRadius: '50%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderColor: theme.palette.text.disabled,
    },
    input: {
      display: 'none',
    },
    image: {
      borderRadius: theme.spacing(2),
      cursor: 'pointer',
    },
  }),
);

export default useStyles;
